import { SET_SCREEN_SHARE_REQUEST_STATUS } from '../Types';

/**
 * Action creator (thunk) to set the current screen share request status.
 *
 * This returns a thunk which dispatches an action of type
 * `SET_SCREEN_SHARE_REQUEST_STATUS` with a payload containing the provided
 * `status` and optional `meta` information.
 *
 * @param {Object} params - Parameters object.
 * @param {string} params.status - New status for the screen share request.
 *   Expected values are defined in `SCREEN_SHARE_REQUEST_STATUS` constant.
 * @param {?Object} [params.sourceId=null] - Optional metadata for the request
 *   (for example `{ sourceId: 'screen-source-123' }`). Use `null` when no
 *   metadata is available.
 *
 * @returns {Function} Thunk function that accepts `dispatch` and dispatches
 * the action.
 *
 * @example
 * // Initiate a screen share request
 * dispatch(setScreenShareRequest({ status: 'requested', sourceId: null }));
 *
 * @example
 * // Approve a screen share and attach the source id
 * dispatch(setScreenShareRequest({ status: 'accepted', sourceId: 'abc' }));
 */
export const setScreenShareRequest = ({ status, sourceId = null }) => {
  return dispatch => {
    const action = {
      type: SET_SCREEN_SHARE_REQUEST_STATUS,
      payload: { status, sourceId }
    };

    dispatch(action);
  };
};
